import { api, RegisterPayload } from '../services/requests';

export async function registerOrLogin(payload: RegisterPayload): Promise<boolean> {
  const errorEl = document.getElementById('form-error') as HTMLElement | null;
  try {

    if (errorEl) errorEl.textContent = "";

    console.log('tentando registrar');

    const register = await api.register(payload);
    console.log('register response:');
    if (errorEl && register.error) {
      errorEl.textContent = register.error?.message;
    }

    if (register.jwt) {
      console.log('registro novo funcionou');
      localStorage.setItem('jwt', register.jwt);
      return true;
    }
    // console.log('payload.email', payload.email);
    // console.log('payload.password', payload.password);
    if (register.error?.message === 'Email or Username are already taken') {
      console.log('usuário já existe, tentando login');

      const login = await api.login({
        identifier: payload.email,
        password: payload.password,
      });

      console.log('login response:', login);

      if (login.jwt) {
        console.log('login funcionou');
        localStorage.setItem('jwt', login.jwt);

        const myCodes = await api.getMyCodes();
        console.log('myCodes:', myCodes);

        if (myCodes.length > 0) {
          const sortedCodes = [...myCodes].sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );

          const latestCode = sortedCodes[0];
          const lastCodeDate = new Date(latestCode.createdAt);
          const today = new Date();

          const hasCodeToday =
            lastCodeDate.getDate() === today.getDate() &&
            lastCodeDate.getMonth() === today.getMonth() &&
            lastCodeDate.getFullYear() === today.getFullYear();

          console.log('latestCode:', latestCode);
          console.log('hasCodeToday:', hasCodeToday);

          if (hasCodeToday) {
            localStorage.setItem('currentCode', latestCode.code);
            console.log('indo para final.html');
            window.location.href = './final.html';
            return false;
          } else {
            localStorage.removeItem('currentCode');
          }

        } else {
          localStorage.removeItem('currentCode');
        }

        return true;
      }

      console.log('login não retornou jwt');
    }

    return false;
  } catch (error: any) {
    console.error('registerOrLogin caiu no catch:', error);
    if (error.message == "Invalid identifier or password") {
      if (errorEl) errorEl.textContent = "Email ou CPF/Passaporte incorretos. Verifique seus dados e tente novamente.";
    } else {
      if (errorEl) errorEl.textContent = error instanceof Error ? error.message : 'Ocorreu um erro inesperado. Tente novamente.';
    }
    return false;
  }
}
export async function validateIntroForm(index: number): Promise<boolean> {
  if (index !== 2) return true;

  const errorEl = document.getElementById('form-error') as HTMLElement | null;

  if (errorEl) {
    errorEl.classList.add('hidden');
    errorEl.textContent = '';
  }

  const values = {
    name: (document.getElementById('name') as HTMLInputElement | null)?.value.trim() || '',
    email: (document.getElementById('email') as HTMLInputElement | null)?.value.trim() || '',
    terms: (document.getElementById('terms') as HTMLInputElement | null)?.checked || false,
    birthday: (document.getElementById('birthdate') as HTMLInputElement | null)?.value.trim() || '',
    gender: (document.getElementById('gender') as HTMLSelectElement | null)?.value.trim() || '',
    cpf: (document.getElementById('cpf') as HTMLInputElement | null)?.value.trim() || '',
  };

  const rules = [
    {
      message: 'Informe seu nome.',
      valid: () => !!values.name,
    },
    {
      message: 'Selecione um gênero.',
      valid: () => !!values.gender,
    },
    {
      message: 'Informe sua data de nascimento.',
      valid: () => !!values.birthday,
    },
    {
      message: 'Informe CPF ou passaporte.',
      valid: () => !!values.cpf,
    },
    {
      message: 'Informe um e-mail válido.',
      valid: () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email),
    },
    {
      message: 'Você precisa aceitar os termos.',
      valid: () => values.terms === true,
    },
  ];

  for (const rule of rules) {
    if (!rule.valid()) {
      if (errorEl) {
        errorEl.textContent = rule.message;
        errorEl.classList.remove('hidden');
      }

      return false;
    }
  }

  const payload: RegisterPayload = {
    username: values.email,
    name: values.name,
    email: values.email,
    password: values.cpf,
    gender: values.gender,
    birthday: values.birthday,
    cpf: values.cpf,
    terms: values.terms,
  };

  try {
    const success = await registerOrLogin(payload);

    if (!success && errorEl) {
      errorEl.classList.remove('hidden');
    }

    return success;
  } catch (error) {
    console.error('Erro ao validar formulário de introdução:', error);

    if (errorEl) {
      errorEl.textContent = 'Ocorreu um erro ao enviar seus dados. Tente novamente.';
      errorEl.classList.remove('hidden');
    }

    return false;
  }
}